import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { navItems } from "../../nav-data";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";

const Sidebar = ({ onMobileNavClick }) => {
  const { userInfo } = useSelector((state) => state.userDetails);
  const [openMenus, setOpenMenus] = useState({});
  const location = useLocation();
  
  // Filter navItems based on the role
  const filteredNavItems = navItems.filter((item) =>
    item.permission.includes(userInfo?.userResponse?.role)
  );

  // Toggle submenu
  const toggleMenu = (id) => {
    setOpenMenus((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const isActiveRoute = (path) => {
    return location.pathname === path;
  };

  const handleNavClick = () => {
    if (onMobileNavClick) {
      onMobileNavClick();
    }
  };

  return (
    <aside className="w-[300px] overflow-y-auto h-full">
      <ul className="menuItems space-y-1 pb-6">
        {filteredNavItems.map((nav) => (
          <li key={nav.id} className="relative">
            {nav.children ? (
              <>
                <div
                  className="cursor-pointer no-underline flex items-center justify-between text-white px-[25px] text-sm py-3 hover:bg-gradient-to-r hover:from-primaryRed/20 hover:to-orange-500/20 transition-all duration-300 rounded-lg mx-2 group"
                  onClick={() => toggleMenu(nav.id)}
                >
                  <div className="flex items-center">
                    <span className="mr-[20px] group-hover:scale-110 transition-transform duration-200">{nav.icon}</span>
                    <span className="font-medium">{nav.name}</span>
                  </div>
                  <IoIosArrowDown className={`transform transition-transform duration-300 ${
                    openMenus[nav.id] ? 'rotate-180' : 'rotate-0'
                  }`} />
                </div>

                <ul
                  className={`transition-all duration-500 ease-in-out overflow-hidden ${
                    openMenus[nav.id] ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  {nav.children.map((sub) => (
                    <li key={sub.id} className="transform transition-all duration-200 hover:translate-x-2">
                      <Link
                        to={sub.path}
                        onClick={handleNavClick}
                        className={`block text-white px-[45px] text-sm py-2 rounded-lg mx-4 transition-all duration-200 ${
                          isActiveRoute(sub.path) 
                            ? 'bg-gradient-to-r from-primaryRed to-orange-500 shadow-lg font-semibold' 
                            : 'hover:bg-white/10 hover:shadow-md'
                        }`}
                      >
                        {sub.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </>
            ) : (
              <Link
                className={`cursor-pointer no-underline flex items-center text-white px-[25px] text-sm py-3 rounded-lg mx-2 transition-all duration-300 group ${
                  isActiveRoute(nav.path)
                    ? 'bg-gradient-to-r from-primaryRed to-orange-500 shadow-lg font-semibold transform scale-105'
                    : 'hover:bg-gradient-to-r hover:from-primaryRed/20 hover:to-orange-500/20 hover:shadow-md'
                }`}
                to={nav.path}
                onClick={handleNavClick}
              >
                <span className="mr-[20px] group-hover:scale-110 transition-transform duration-200">{nav.icon}</span>
                <span className="font-medium">{nav.name}</span>
              </Link>
            )}
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default Sidebar;
